export default __webpack_public_path__ + "static/media/LukaszSiekiewicz_DynamikaRozowju.d04f183c.png";